module.exports = __webpack_public_path__ + "static/diagram-97464a235ef40ce7eafc205416990436.png";